module.exports = __webpack_public_path__ + "img/excl-point-inverse.df717e73.png";